import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {

  const [socket, setSocket] = useState(null);
  const [socketId, setSocketId] = useState(null);

  // useEffect(() => {

  //   const token = localStorage.getItem("token");

  //   if (!token) return; // Ne se connecte que si le token est présent

  //   const newSocket = io(process.env.REACT_APP_API_URL, {

  //     query: { token },
  //     reconnectionAttempts: 5,
  //     reconnectionDelay: 5000,

  //   });

  //   setSocket(newSocket);

  //   newSocket.on("allowed", () => {

  //     console.log("✅ WebSocket connecté :", newSocket.id);
  //     setSocketId(newSocket.id)


  //   });

  //   newSocket.on("disconnect", (reason) => {

  //     console.log("❌ Déconnecté :", reason);

  //   });

  //   return () => {

  //     newSocket.disconnect();

  //   };

  // }, [localStorage.getItem("token")]); // 🔥 Déclenche l'effet seulement si le token change

  
  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
